import React, {Component} from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
import HrStore from '../../stores/HrStore'

const DEFAULT_META = {requested_by:'',director:'',finance_manager:'',finance_title:'ผู้จัดการฝ่ายการเงิน'}
class PrintReportSummarySlip extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,data:[],meta:DEFAULT_META}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('landscape');
  }

  componentDidMount(){
    this.loadData()
  }

  loadData() {
		let {meta} = this.state
  	this.setState({loading:true}) 
  	let rangeValue = {value:this.props.between,startDate:this.props.start,endDate:this.props.end}
    
    HrStore.loadAllSlipSummary(this.props.year,this.props.month,rangeValue,(result)=>{

      this.setState({loading:false,data:result.data,meta:result.meta})
    },(error)=>{
                
    })
  }

  renderComponentPage() {
	let {meta} = this.state
	let finance_title = meta.finance_title!==''?meta.finance_title:DEFAULT_META.finance_title
	return(
      <div className='font-print'>
        <div className='text-center font-24'>{'สรุปค่าแรงพนักงาน ประจำวันที่ '+this.props.between+' '+this.getTextMonth()+' '+this.props.year}</div>  
        <div>
        	{this.renderTable()}
        	<center>
		        <div className='footer-page-landscape'>
		          <table className='table table-print-report-contractor-wage-foot'>
		            <tbody>
		              <tr>
		                <td className='text-center font-print'>
		                  .....................................................................<br/>
		                  {meta.requested_by}<br/>
		                  ผู้ขออนุมัติ
		                </td>
		                <td className='text-center font-print'>
		                  .....................................................................<br/>
		                  {meta.finance_manager}<br/>
		                  {finance_title}
		                </td>
		                <td className='text-center font-print'>
		                  .....................................................................<br/>
		                  {meta.director}<br/>
		                  กรรมการผู้จัดการ
		                </td>
		              </tr>
		            </tbody>
		          </table>
		        </div>
		    </center>
        </div>
      </div>
    )
  } 

  renderTable() {
  	return(
  			<table className='table table-responsive table-print-report-summary-slip'>
	            <tbody>
	              <tr>
	                <td style={{width:'50px'}} className='text-center'>ลำดับ</td>
	                <td style={{width:'350px'}} className='text-center'>รายการ</td>
	                <td className='text-center'>วันละ/เดือน</td>
	                <td className='text-center'>ค่าแรง</td>
	                <td className='text-center'>เบิก</td>
	                <td className='text-center'>ชั่วโมง OT</td>
	                <td className='text-center'>OT อาทิตย์</td>
	                <td className='text-center'>จำนวนเงิน OT</td>
	                <td className='text-center'>หักเบิก</td>
	                <td className='text-center'>คงเหลือ</td>
	                <td className='text-center'>คงเหลือค้างจ่าย</td>
	              </tr>
	              {this.renderRowData()}
                {this.renderFooter()}
	            </tbody>
	        </table>
  	)
  }

  renderFooter() {
    return (
      <tr>
        <td className='text-center' colSpan={2}>{'รวมค่าแรงพนักงาน ประจำวันที่ '+this.props.between+' '+this.getTextMonth()+' '+this.props.year}</td>
        <td className='text-right'>{this.getSummary('salary')}</td>
        <td className='text-right'>{this.getSummary('wage_amount')}</td>
        <td className='text-right'>{this.getSummary('withdraw_amount')}</td>
        <td className='text-right'>{this.getSummary('ot_hour')}</td>
        <td className='text-right'>{this.getSummary('ot_sunday')}</td>
        <td className='text-right'>{this.getSummary('ot_amount')}</td>
        <td className='text-right'>{this.getSummary('deduction_withdraw')}</td>
        <td className='text-right'>{this.getSummary('net_balance')}</td>
        <td className='text-right'>{this.getSummary('net_unpaid')}</td>
      </tr>
    )
  }

  getValue(value) {
    if (isNaN(value)||value===undefined||value===''||value===null) {
      return value
    } else {
      return value.toLocaleString(undefined, {maximumFractionDigits: 2})
    }  
  }

  getSummary(key) {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      if (isNaN(item[key])||item[key]===undefined||item[key]===''||item[key]===null) {
        item[key] = 0 
      }
      sum = parseFloat(item[key]) + parseFloat(sum)
    })
    return sum.toLocaleString(undefined, {maximumFractionDigits: 2})
  }

  renderRowData() {
  	let {data} = this.state
  	if (data.length===0||data===undefined) {
  		return(<tr><td colSpan={11}>ไม่พบข้อมูล</td></tr>)
  	} else {
  		return(
  			data.map((item,index) => {
  				return(
  					<tr key={index}>
  					  <td className='text-center'>{index+1}</td>
			          <td>{this.getValue(item.description)}</td>
			          <td className='text-right'>{this.getValue(item.salary)}</td>
			          <td className='text-right'>{this.getValue(item.wage_amount)}</td>
			          <td className='text-right'>{this.getValue(item.withdraw_amount)}</td>
			          <td className='text-right'>{this.getValue(item.ot_hour)}</td>
			          <td className='text-right'>{this.getValue(item.ot_sunday)}</td>
			          <td className='text-right'>{this.getValue(item.ot_amount)}</td>
			          <td className='text-right'>{this.getValue(item.deduction_withdraw)}</td>
			          <td className='text-right'>{this.getValue(item.net_balance)}</td>
			          <td className='text-right'>{this.getValue(item.net_unpaid)}</td>
  					</tr>
  				)
  			})
  		)
  	}
  }   		    

  render() {
  	let {loading} = this.state
  	return(
      <PrintPreview 
        loading={loading} 
        size={'landscape'} 
        leftBarTitle={'สรุปค่าแรงพนักงาน ประจำวันที่ '+this.props.between+' '+this.getTextMonth()+' '+this.props.year}
      >
      	{this.renderComponentPage()} 
      </PrintPreview>
    )
  }

  getTextMonth() {
  	let text = ''
  	let {month} = this.props
  	if (month==='01'||month==='1') {
  		text = 'มกราคม'
  	} else if (month==='02'||month==='2') {
  		text = 'กุมภาพันธ์'
  	} else if (month==='03'||month==='3') {
  		text = 'มีนาคม'
  	} else if (month==='04'||month==='4') {
  		text = 'เมษายน'
  	} else if (month==='05'||month==='5') {
  		text = 'พฤษภาคม'
  	} else if (month==='06'||month==='6') {
  		text = 'มิถุนายน'
  	} else if (month==='07'||month==='7') {
  		text = 'กรกฎาคม'
  	} else if (month==='08'||month==='8') {
  		text = 'สิงหาคม'
  	} else if (month==='09'||month==='9') {
  		text = 'กันยายน'
  	} else if (month==='10') {
  		text = 'ตุลาคม'
  	} else if (month==='11') {
  		text = 'พฤศจิกายน'
  	} else if (month==='12') {
  		text = 'ธันวาคม'
  	}
  	return text
  }

}

export default PrintReportSummarySlip;


// WEBPACK FOOTER //
// ./src/view/print/PrintReportSummarySlip.js